import { HsaReimbursementAccountType } from "@redotech/crdb-enums/conversion/hsa-reimbursement-account-type";
import { HsaReimbursementClaimStatus } from "@redotech/crdb-enums/conversion/hsa-reimbursement-claim-status";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getHsaReimbursementEligibility = {
  name: "getHsaReimbursementEligibility" as const,
  input: z.object({
    orderId: zExt.objectId(),
    /** Resolve product images for the eligible lines (a Shopify read); the CTA check leaves this off. */
    includeLineItems: z.boolean().optional(),
  }),
  output: z.object({
    eligible: z.boolean(),
    canSubmit: z.boolean(),
    alreadyClaimed: z.boolean(),
    eligibleAmount: z.string(),
    eligibleLineCount: z.number(),
    eligibleLineItems: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        variantTitle: z.string().nullable(),
        imageUrl: z.string().nullable(),
        quantity: z.number(),
        totalPrice: z.string(),
        /** Claimable only with an LMN, through the LMN questionnaire. */
        requiresLmn: z.boolean(),
      }),
    ),
    orderName: z.string(),
    email: z.string().nullable(),
    currency: z.string(),
    /** The existing claim on this order, when one has been filed. */
    claim: z
      .object({
        id: z.string(),
        provider: z.string(),
        accountType: createEnum(HsaReimbursementAccountType),
        status: createEnum(HsaReimbursementClaimStatus),
        eligibleAmount: z.string(),
        /** Every line id the claim covers. */
        lineItemIds: z.array(z.string()),
      })
      .nullable(),
    prefill: z.object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      phone: z.string(),
      street: z.string(),
      city: z.string(),
      state: z.string(),
      zip: z.string(),
    }),
  }),
};
